export default __webpack_public_path__ + "static/media/4.e65a3f3d.svg";